import { render, staticRenderFns } from "./sessoes-mensais.vue?vue&type=template&id=8446a42c"
import script from "./sessoes-mensais.vue?vue&type=script&lang=js"
export * from "./sessoes-mensais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports